import LoanProductScreen from './LoanProductScreen';

export default LoanProductScreen;
